interface AnalyticsFunnelProps {
  storeViews: number;
  productViews: number;
  whatsappClicks: number;
}

function formatPassThrough(numerator: number, denominator: number): string {
  if (denominator <= 0) return "—";
  const percentage = Math.round((numerator / denominator) * 100);
  return `${percentage}% passam`;
}

function FunnelStep({ label, count }: { label: string; count: number }) {
  return (
    <div className="flex-1 min-w-0 border border-primary-200 dark:border-primary-800 bg-white dark:bg-primary-900 p-4 sm:p-6 text-center">
      <p className="text-xs font-light tracking-widest uppercase text-primary-600 dark:text-primary-400 mb-3">
        {label}
      </p>
      <p className="text-3xl sm:text-4xl font-light tracking-tight text-primary-900 dark:text-white">
        {count.toLocaleString("pt-BR")}
      </p>
    </div>
  );
}

function PassThrough({ label }: { label: string }) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-2 shrink-0">
      <span className="text-primary-400 dark:text-primary-500 text-xl" aria-hidden="true">
        →
      </span>
      <p className="text-xs font-light tracking-wide text-primary-600 dark:text-primary-400 mt-2 whitespace-nowrap">
        {label}
      </p>
    </div>
  );
}

export default function AnalyticsFunnel({
  storeViews,
  productViews,
  whatsappClicks,
}: AnalyticsFunnelProps) {
  const storeToProduct = formatPassThrough(productViews, storeViews);
  const productToWhatsapp = formatPassThrough(whatsappClicks, productViews);

  return (
    <section aria-label="Funil de conversão">
      <div className="flex flex-col lg:flex-row lg:items-stretch gap-2 lg:gap-0">
        <FunnelStep label="Visualizações da loja" count={storeViews} />
        <PassThrough label={storeToProduct} />
        <FunnelStep label="Visualizações de produto" count={productViews} />
        <PassThrough label={productToWhatsapp} />
        <FunnelStep label="Cliques WhatsApp" count={whatsappClicks} />
      </div>
    </section>
  );
}
